import { call, put, takeLatest } from 'redux-saga/effects';
import { clientDiagnosisService } from './clientDiagnosis.service';
import {
    CREATE_CLIENT_DIAGNOSIS,
    DELETE_CLIENT_DIAGNOSIS,
    EDIT_CLIENT_DIAGNOSIS,
    GET_CLIENT_DIAGNOSES,
    GET_CLIENT_DIAGNOSES_SUCCESS,
    GET_DIAGNOSIS_MATCH,
    GET_DIAGNOSIS_MATCH_SUCCESS,
    SET_PRIMARY_CLIENT_DIAGNOSIS,
} from './clientDiagnosis.types';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

const errorMessage = (err) => (err?.data?.message ? err?.data?.message : err?.response?.data?.message);

function* getClientDiagnoses({ type, payload }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(clientDiagnosisService.getClientDiagnosesService, payload.clientId);
        yield put({ type: GET_CLIENT_DIAGNOSES_SUCCESS, payload: res.data });
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(type, errorMessage(err)));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

/**
 * Every write re-fetches the list instead of patching it: one write can touch other rows
 * (a new primary unsets the old one), and the api owns the derived `status` / `usedOnClaim`.
 */
function* writeAndRefetch(type, request, clientId) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield request;
        if (clientId) yield put({ type: GET_CLIENT_DIAGNOSES, payload: { clientId } });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, res?.data));
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(type, errorMessage(err)));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* createClientDiagnosis({ type, payload }) {
    yield* writeAndRefetch(
        type,
        call(clientDiagnosisService.createClientDiagnosisService, payload.clientId, payload.body),
        payload.clientId
    );
}

function* editClientDiagnosis({ type, payload }) {
    yield* writeAndRefetch(type, call(clientDiagnosisService.editClientDiagnosisService, payload.id, payload.body), payload.clientId);
}

function* setPrimaryClientDiagnosis({ type, payload }) {
    yield* writeAndRefetch(type, call(clientDiagnosisService.setPrimaryClientDiagnosisService, payload.id), payload.clientId);
}

function* deleteClientDiagnosis({ type, payload }) {
    yield* writeAndRefetch(type, call(clientDiagnosisService.deleteClientDiagnosisService, payload.id), payload.clientId);
}

function* getDiagnosisMatch({ type, payload }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(clientDiagnosisService.getDiagnosisMatchService, payload.params);
        yield put({ type: GET_DIAGNOSIS_MATCH_SUCCESS, payload: res.data });
    } catch (err) {
        yield put({ type: GET_DIAGNOSIS_MATCH_SUCCESS, payload: null });
        yield put(httpRequestsOnErrorsActions.appendError(type, errorMessage(err)));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

export const watchClientDiagnosis = function* watchClientDiagnosisSaga() {
    yield takeLatest(GET_CLIENT_DIAGNOSES, getClientDiagnoses);
    yield takeLatest(CREATE_CLIENT_DIAGNOSIS, createClientDiagnosis);
    yield takeLatest(EDIT_CLIENT_DIAGNOSIS, editClientDiagnosis);
    yield takeLatest(SET_PRIMARY_CLIENT_DIAGNOSIS, setPrimaryClientDiagnosis);
    yield takeLatest(DELETE_CLIENT_DIAGNOSIS, deleteClientDiagnosis);
    yield takeLatest(GET_DIAGNOSIS_MATCH, getDiagnosisMatch);
};
